import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { LoadingIndicator } from 'components/styled/loading-indicator'
import { Box } from 'components/styled/containers/box'
import { addError } from 'actions'

/**
 * Component that will display spinner while action is fetching data.
 */

interface FetchWithSpinnerProps {
  action: () => any // for now, not sure about all the types the action can be
  /*  | Promise<void>
    | (() => (dispatch: any) => Promise<void>)
    | (() => void) */
  children: React.ReactElement<any, any> | null | any
  dispatch: any
}

export const FetchWithSpinner = ({
  action,
  children,
  dispatch,
}: FetchWithSpinnerProps) => {
  const [fetching, setFetching] = useState<boolean>(true)
  const [hasError, setHasError] = useState<boolean>(false)

  useEffect(() => {
    dispatch(action()).then(() => setFetching(false)).catch((error) => {
      dispatch(addError(error))
      setHasError(true)
      setFetching(false)
    })
  }, [])

  if (fetching || hasError) {
    return (
      <Box mt="s96">
        <LoadingIndicator />
      </Box>
    )
  }
  return children
}

export default connect()(FetchWithSpinner)
